import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "dropdown"];

  connect() {
    this.activeClasses = "opacity-100 scale-100 ease-in duration-75".split(" ");
    this.inactiveClasses =
      "opacity-0 scale-95 ease-out duration-100 pointer-events-none".split(" ");
    this.hideOnScroll = this.hide.bind(this);
  }

  disconnect() {
    this.stopFloating();
  }

  toggle(event) {
    event.preventDefault();

    if (this.buttonTarget.getAttribute("aria-expanded") === "false") {
      this.show();
    } else {
      this.hide(null);
    }
  }

  show() {
    this.buttonTarget.setAttribute("aria-expanded", "true");
    this.buttonTarget.focus();
    this.float();
    this.dropdownTarget.classList.remove(...this.inactiveClasses);
    this.dropdownTarget.classList.add(...this.activeClasses);
  }

  hide(event) {
    if (
      event &&
      ((this.dropdownTarget.contains(event.target) &&
        event.type !== "mouseleave") ||
        this.buttonTarget.contains(event.target))
    ) {
      return;
    }

    this.stopFloating();
    this.buttonTarget.setAttribute("aria-expanded", "false");
    this.buttonTarget.blur();
    this.dropdownTarget.classList.add(...this.inactiveClasses);
    this.dropdownTarget.classList.remove(...this.activeClasses);
  }

  // Pins the open menu with fixed positioning where its classes place it, so
  // overflow containers such as TableComponent can't clip it. Flips above the
  // button when there is no room below. Scrolling or resizing closes it.
  float() {
    const menu = this.dropdownTarget;
    this.resetFloat();
    menu.style.transform = "none";
    const rect = menu.getBoundingClientRect();
    const button = this.buttonTarget.getBoundingClientRect();
    const gap = rect.top - button.bottom;
    let { top } = rect;
    if (
      rect.bottom > window.innerHeight &&
      button.top - gap - rect.height >= 0
    ) {
      top = button.top - gap - rect.height;
    }
    Object.assign(menu.style, {
      position: "fixed",
      top: `${top}px`,
      left: `${rect.left}px`,
      right: "auto",
      bottom: "auto",
      margin: "0",
      width: `${rect.width}px`,
    });
    window.addEventListener("scroll", this.hideOnScroll, true);
    window.addEventListener("resize", this.hideOnScroll);
  }

  resetFloat() {
    [
      "position",
      "top",
      "left",
      "right",
      "bottom",
      "margin",
      "width",
      "transform",
    ].forEach((property) => this.dropdownTarget.style.removeProperty(property));
  }

  stopFloating() {
    window.removeEventListener("scroll", this.hideOnScroll, true);
    window.removeEventListener("resize", this.hideOnScroll);
  }
}
